// Custom phone input with auto-format
import { forwardRef } from 'react';

const formatPhoneNumber = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');
    
    // Apply format: xx-xxxx-xxxx
    if (digits.length <= 2) {
        return digits;
    } else if (digits.length <= 6) {
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
    } else {
        return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
    }
};

const PhoneInput = forwardRef(({ onChange, value, invalid, className, ...props }, ref) => {
    const handleChange = (e) => {
        const formatted = formatPhoneNumber(e.target.value);
        // Trigger onChange with formatted value
        onChange?.({
            ...e,
            target: {
                ...e.target,
                value: formatted,
            },
        });
    };

    return (
        <input
            {...props}
            ref={ref}
            type="text"
            value={value}
            onChange={handleChange}
            maxLength={12} // xx-xxxx-xxxx = 12 chars
            className={`border px-3 py-2 ${
                invalid ? 'border-red-700' : 'border-gray-300'
            } focus:outline-none ${className ?? ''}`}
        />
    );
});

PhoneInput.displayName = 'PhoneInput';
export default PhoneInput;